import { FormattedMessage } from 'react-intl'

export const TaxationTaxIdentificationNumberMessage = (
  <FormattedMessage id="taxation.form.label.taxIdentificationNumber" defaultMessage="Adóazonosító jeled" />
)
